const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNinjaPana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-98"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 246.89,
    cy: 186.93,
    r: 142.09,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.92,
    cy: 117.18,
    r: 21.1,
    transform: "translate(-20.08 135.06) rotate(-22.86)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.19,
    cy: 152.81,
    r: 9.89,
    transform: "translate(175.21 490.92) rotate(-86.8)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.66,
    cy: 146.94,
    r: 8.62,
    transform: "translate(-41.51 241.47) rotate(-76.77)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.81,
    cy: 121.6,
    r: 2.52,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.93,56.6c.78-5.7-7.26-10.38-13.3-10.87-2.88-.23-5.87.21-8.6-.74-5.92-2.07-8.28-9.71-14-12.14-4.32-1.82-9.28-.2-13.47,1.9s-8.31,4.76-13,5.06c-4.06.26-8.47-1.25-12,.74-2.65,1.48-4,4.53-6.48,6.33S76.5,49,73.54,49.18s-6,.19-8.74,1.43-4.93,4.09-4.37,7Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.93,98.14c.6-4.37-5.57-8-10.21-8.34-2.21-.18-4.51.16-6.6-.57-4.54-1.58-6.36-7.45-10.79-9.32-3.31-1.39-7.12-.15-10.33,1.47s-6.38,3.65-10,3.87c-3.12.2-6.51-1-9.24.57-2,1.14-3.1,3.48-5,4.86s-4.23,1.64-6.51,1.77-4.63.14-6.7,1.09-3.79,3.14-3.36,5.38Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,100.61c.5-3.59-4.57-6.54-8.38-6.85-1.81-.14-3.7.13-5.42-.47C78.5,92,77,87.18,73.37,85.65c-2.71-1.15-5.84-.13-8.48,1.2s-5.24,3-8.18,3.18c-2.56.17-5.34-.78-7.58.47-1.67.93-2.55,2.85-4.09,4a9.77,9.77,0,0,1-5.33,1.45,15.16,15.16,0,0,0-5.5.89c-1.71.78-3.11,2.58-2.76,4.42Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.84,293c.62-4.51-5.74-8.21-10.51-8.59-2.28-.19-4.64.16-6.8-.59-4.67-1.63-6.54-7.67-11.1-9.59-3.41-1.44-7.34-.16-10.64,1.5s-6.57,3.76-10.26,4c-3.22.2-6.71-1-9.52.58-2.09,1.17-3.19,3.58-5.12,5s-4.35,1.68-6.69,1.81-4.77.15-6.9,1.13-3.9,3.23-3.46,5.54Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.52 365.38 127.19 365.38 151.19 437.02 134.8 365.38 139.48 365.38 160.56 437.02 149.44 365.38 180.77 365.38 207.99 475.47 189.43 365.38 193.25 365.38 216.15 475.47 218.82 483.16 117.35 483.16 105.52 365.38",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.23 365.38 62.9 365.38 86.9 437.02 70.51 365.38 75.19 365.38 96.27 437.02 85.15 365.38 116.48 365.38 143.7 475.47 125.14 365.38 128.96 365.38 151.85 475.47 154.53 483.16 67.53 483.16 41.23 365.38",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.94 365.38 259.61 365.38 283.62 437.02 267.22 365.38 271.91 365.38 292.99 437.02 281.86 365.38 313.19 365.38 340.41 475.47 321.85 365.38 325.68 365.38 348.57 475.47 349.65 483.16 249.82 483.71 237.94 365.38",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.46 366.21 360.12 366.21 384.13 437.86 367.74 366.21 372.42 366.21 393.5 437.86 382.38 366.21 413.71 366.21 440.93 476.3 422.37 366.21 426.19 366.21 449.08 476.3 449.08 482.88 350.17 482.88 338.46 366.21",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.78,362.75c-.49,1.25,7.84,65.53,17,79s17.95,41.37,17.95,41.37h7s-15.82-36.45-22.7-56.54S210,362.75,210,362.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,379.47a1.57,1.57,0,0,1,.17.22l.47.68L29.38,383c.77,1.14,1.68,2.54,2.68,4.21s2.21,3.54,3.4,5.68,2.56,4.45,3.9,7,2.75,5.3,4.2,8.2c2.81,5.84,5.71,12.36,8.4,19.34s4.88,13.77,6.69,20c.86,3.13,1.71,6.09,2.36,8.9s1.28,5.42,1.79,7.81.91,4.58,1.27,6.5.63,3.56.83,4.92.34,2.37.46,3.12c0,.34.07.6.1.82a1.17,1.17,0,0,1,0,.28,1.24,1.24,0,0,1-.07-.28c0-.21-.09-.47-.16-.8-.13-.75-.32-1.79-.55-3.11s-.52-3-.92-4.9-.78-4.09-1.34-6.47-1.12-5-1.85-7.79-1.53-5.75-2.4-8.87c-1.83-6.2-4-13-6.71-19.95s-5.57-13.48-8.35-19.32c-1.44-2.89-2.78-5.66-4.15-8.19s-2.63-4.9-3.84-7-2.34-4-3.33-5.71-1.86-3.1-2.6-4.25l-1.66-2.68-.42-.71C27,379.56,27,379.48,27,379.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.48,467.38a.84.84,0,0,1,0-.27c0-.21-.06-.48-.1-.81-.07-.75-.18-1.79-.31-3.1s-.29-3-.55-4.91-.47-4.08-.86-6.47c-.18-1.2-.37-2.45-.57-3.76s-.48-2.65-.72-4.05c-.47-2.81-1.13-5.78-1.79-8.91-1.41-6.24-3.19-13.05-5.41-20.09s-4.76-13.61-7.22-19.52c-1.27-2.93-2.45-5.74-3.69-8.3-.61-1.28-1.17-2.54-1.77-3.72l-1.7-3.39c-1.06-2.18-2.14-4.09-3-5.78S36,371.15,35.3,370l-1.54-2.71-.38-.71c-.09-.17-.13-.25-.12-.26a1.74,1.74,0,0,1,.16.23c.11.18.26.4.43.68l1.63,2.67c.7,1.16,1.55,2.58,2.47,4.28s2,3.58,3.11,5.75l1.75,3.38c.6,1.18,1.17,2.43,1.79,3.72,1.26,2.56,2.45,5.36,3.75,8.29,2.48,5.91,5,12.51,7.26,19.56s4,13.88,5.39,20.14c.65,3.14,1.29,6.12,1.74,8.93.24,1.41.5,2.76.69,4.07s.37,2.57.54,3.77c.37,2.39.57,4.58.79,6.49s.37,3.57.46,4.92.17,2.36.22,3.11l0,.81A1,1,0,0,1,65.48,467.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.3,357a1.68,1.68,0,0,1,0,.33c0,.25,0,.57,0,1,0,.89.09,2.14.16,3.75,0,.81.06,1.72.1,2.71s.14,2.06.21,3.21c.17,2.31.3,4.94.63,7.84.14,1.45.29,3,.45,4.55s.4,3.21.61,4.91c.39,3.41,1,7,1.58,10.82,1.28,7.59,2.93,15.9,4.94,24.56,4.1,17.3,8.7,32.74,12.05,43.91,1.67,5.55,3,10.06,4,13.21.46,1.54.82,2.74,1.07,3.6q.16.58.27.93a1.24,1.24,0,0,1,.07.33,1.41,1.41,0,0,1-.12-.31l-.32-.92c-.27-.85-.67-2.05-1.16-3.57-1-3.1-2.43-7.6-4.16-13.17-3.44-11.13-8.09-26.57-12.19-43.89-2-8.67-3.66-17-4.92-24.6-.57-3.81-1.16-7.43-1.53-10.84-.2-1.71-.43-3.35-.58-4.93s-.29-3.11-.42-4.56C168.14,364.2,168.3,357,168.3,357Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.06,476.93l-.21-.23c-.14-.19-.34-.43-.57-.74l-2.19-2.85L236.52,471c-.55-.76-1.13-1.62-1.76-2.53-1.24-1.84-2.73-3.88-4.17-6.28l-2.33-3.71c-.8-1.3-1.55-2.7-2.37-4.12-1.67-2.83-3.23-6-4.92-9.26a184.74,184.74,0,0,1-15.47-45.36c-.67-3.63-1.36-7.08-1.76-10.34-.22-1.63-.49-3.19-.64-4.71s-.3-3-.44-4.36c-.32-2.77-.39-5.3-.53-7.51,0-1.11-.12-2.14-.15-3.09s0-1.81,0-2.6c0-1.53,0-2.74,0-3.59,0-.39,0-.7,0-.94a1,1,0,0,1,0-.31,1.2,1.2,0,0,1,0,.31c0,.24,0,.55,0,.94,0,.85.07,2.06.12,3.59,0,.78,0,1.65.07,2.59s.12,2,.19,3.08c.17,2.21.26,4.73.61,7.5.15,1.38.3,2.83.46,4.35s.45,3.07.67,4.69c.42,3.25,1.13,6.68,1.81,10.3a189,189,0,0,0,15.43,45.25c1.68,3.28,3.22,6.43,4.87,9.26.81,1.42,1.55,2.82,2.34,4.12s1.56,2.54,2.29,3.73c1.42,2.4,2.88,4.45,4.1,6.3.62.92,1.18,1.78,1.73,2.56l1.53,2.1,2.1,2.91.54.76A2.1,2.1,0,0,1,241.06,476.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.6,469.59a1,1,0,0,1-.11-.26l-.26-.78-1-3c-.83-2.62-2-6.43-3.36-11.15-2.77-9.44-6.38-22.54-9.95-37.11s-6.41-27.87-8.31-37.52c-1-4.82-1.7-8.73-2.17-11.44-.23-1.33-.42-2.37-.55-3.12l-.13-.81a1.19,1.19,0,0,1,0-.28,1.25,1.25,0,0,1,.08.27c0,.21.1.47.18.8.15.75.36,1.78.63,3.1.56,2.73,1.36,6.62,2.34,11.41,2,9.62,4.89,22.89,8.46,37.46s7.12,27.68,9.79,37.14c1.35,4.7,2.44,8.51,3.2,11.19l.87,3c.09.32.16.58.21.79A1,1,0,0,1,240.6,469.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.16,353.05a2,2,0,0,1,0,.33c0,.25,0,.56-.09,1-.09.88-.22,2.12-.39,3.7-.35,3.21-.82,7.87-1.36,13.63s-1.09,12.61-1.6,20.24-.92,16-1.21,24.84-.37,17.22-.37,24.86.14,14.53.31,20.31.34,10.46.5,13.69c.06,1.58.11,2.83.14,3.72,0,.4,0,.72,0,1a1.8,1.8,0,0,1,0,.34,1.68,1.68,0,0,1,0-.33c0-.25-.05-.57-.08-1-.06-.88-.14-2.13-.25-3.71-.21-3.23-.44-7.91-.66-13.69s-.37-12.67-.42-20.31.06-16.07.33-24.89.74-17.22,1.25-24.85,1.13-14.49,1.72-20.25,1.11-10.41,1.52-13.61c.21-1.58.37-2.82.49-3.7.05-.4.1-.71.13-1A1.76,1.76,0,0,1,452.16,353.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.17,392.92a2,2,0,0,1-.08.23c-.07.17-.15.38-.26.64-.25.6-.6,1.42-1,2.45s-1,2.36-1.62,3.89-1.34,3.25-2,5.2-1.52,4.05-2.27,6.36-1.55,4.79-2.36,7.4c-1.53,5.24-3,11.06-4.29,17.24s-2.11,12.14-2.73,17.57c-.27,2.71-.55,5.3-.69,7.72s-.29,4.69-.37,6.75-.1,3.94-.14,5.58,0,3.06,0,4.22,0,2,0,2.66v.69a1.1,1.1,0,0,1,0,.24.75.75,0,0,1,0-.24c0-.18,0-.41,0-.69,0-.65-.07-1.54-.11-2.66S448,475.6,448,474s0-3.52.06-5.59.13-4.34.31-6.77.39-5,.64-7.75c.6-5.44,1.46-11.41,2.7-17.61s2.78-12,4.34-17.28c.82-2.61,1.58-5.11,2.41-7.4s1.58-4.42,2.33-6.35,1.48-3.66,2.11-5.18,1.21-2.81,1.71-3.86.85-1.82,1.13-2.41c.12-.25.22-.46.31-.63A.93.93,0,0,1,466.17,392.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.8,456.4c-.14,0-3.77-21.08-8.1-47.13S333,362.07,333.11,362s3.77,21.08,8.1,47.14S349,456.38,348.8,456.4Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.87,483.16c0,.15-99.34.26-221.86.26s-221.88-.11-221.88-.26,99.32-.26,221.88-.26S471.87,483,471.87,483.16Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.77,437.88a8.45,8.45,0,0,1,4.35,4.93,14.93,14.93,0,0,1,.58,6.68c-.5,4.33-3,8.71-5.61,12.17-3.65-3.19-4.49-8.74-4.74-11.59-.39-4.49,1.63-12.86,5.42-12.19",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.33,468.81a7.17,7.17,0,0,1,2.32-6.81,9.48,9.48,0,0,1,7-2.19,4,4,0,0,1,3.08,1.38,3.06,3.06,0,0,1,.05,3.11,6.24,6.24,0,0,1-2.3,2.26c-3.16,2-6.58,3.32-10.16,2.25",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.65,482.09a5.5,5.5,0,0,1,.13-.88c.12-.63.27-1.44.44-2.41a25.49,25.49,0,0,1,2.49-7.69,15.41,15.41,0,0,1,5.51-5.86,10.72,10.72,0,0,1,2.25-1,5.84,5.84,0,0,1,.65-.17.67.67,0,0,1,.23,0,16.36,16.36,0,0,0-3,1.38,15.92,15.92,0,0,0-5.36,5.83,27.06,27.06,0,0,0-2.54,7.57c-.22,1-.4,1.83-.54,2.39A3.84,3.84,0,0,1,392.65,482.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.79,444.39a1.69,1.69,0,0,1,0,.39q0,.44.06,1.11c.05,1,.11,2.38.17,4.12.11,3.47.2,8.27.18,13.57s-.16,10.1-.3,13.57c-.07,1.73-.14,3.14-.2,4.11,0,.45-.06.82-.08,1.11s0,.39-.05.39a2.39,2.39,0,0,1,0-.39c0-.29,0-.66,0-1.12,0-1,.05-2.4.1-4.11.08-3.47.18-8.27.2-13.57s0-10.09-.09-13.56c0-1.71,0-3.1-.06-4.11,0-.46,0-.83,0-1.12A1.65,1.65,0,0,1,392.79,444.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,471.45a16.74,16.74,0,0,0-9.15-12.28c-1.22-.58-2.81-1-3.81-.06s-.78,2.54-.29,3.8a14.3,14.3,0,0,0,13.16,8.89",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.46,463.28a4,4,0,0,1,.78.34,8.88,8.88,0,0,1,.87.47,12.69,12.69,0,0,1,1.11.69,15.79,15.79,0,0,1,1.28,1,16.74,16.74,0,0,1,1.35,1.24,18.17,18.17,0,0,1,2.58,3.31,18.45,18.45,0,0,1,1.7,3.83,17.71,17.71,0,0,1,.43,1.79,14.21,14.21,0,0,1,.22,1.58c.06.48,0,.92.06,1.31a9.65,9.65,0,0,1,0,1,3.44,3.44,0,0,1-.1.84c-.07,0,.06-1.2-.16-3.12a14.17,14.17,0,0,0-.25-1.55,16.74,16.74,0,0,0-.45-1.75,18.44,18.44,0,0,0-1.69-3.76,19.28,19.28,0,0,0-2.51-3.27c-.45-.45-.88-.88-1.32-1.24s-.85-.68-1.23-1C383.53,463.84,382.43,463.34,382.46,463.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.72,437.52a33.31,33.31,0,0,1,7.85-22.38C138.75,426.05,127.72,437.52,127.72,437.52Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.28,430.71A33.33,33.33,0,0,1,163.93,429C155.2,436.24,140.28,430.71,140.28,430.71Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.42,423.5A26.24,26.24,0,0,1,143.81,405C148.05,412.85,141.42,423.5,141.42,423.5Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.59,400c19,4.15,29.81,20,29.81,20C104.35,420.73,90.59,400,90.59,400Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.92,406.31c-1.89-20.19,16.84-44,16.84-44-1.84,25.26-16.84,44-16.84,44",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.21,348.69a54.31,54.31,0,0,1-5.8,29.31C109,365.11,118.21,348.69,118.21,348.69Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.45,390.15c-14.87-.92-23.59-15.27-23.59-15.27C107,379.08,112.45,390.15,112.45,390.15Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.35,453.46a33.29,33.29,0,0,1,23.06-5.54C99,456.5,83.35,453.46,83.35,453.46Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,458.36A21.82,21.82,0,0,1,112.55,470C112.88,463.15,122,458.36,122,458.36Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,456.27c-8.18,5.56-17.55,4-17.55,4C107.86,454,120,456.27,120,456.27Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.79,483.16a1,1,0,0,1,0-.3c0-.24,0-.53-.05-.88,0-.83-.1-2-.17-3.39s-.13-3.27-.27-5.36-.24-4.47-.47-7.09c-.37-5.26-1-11.5-1.88-18.41s-2.1-14.47-3.62-22.36c-3.06-15.78-6.9-29.84-9.93-39.93-1.53-5-2.81-9.11-3.73-11.91-.44-1.36-.78-2.44-1-3.23-.1-.34-.19-.62-.26-.85a1.09,1.09,0,0,1-.06-.29,1.16,1.16,0,0,1,.13.27c.08.23.19.5.31.83.29.78.67,1.85,1.15,3.19,1,2.78,2.35,6.83,3.94,11.86a375.31,375.31,0,0,1,10.13,39.94c1.52,7.9,2.69,15.49,3.58,22.4s1.43,13.19,1.74,18.45c.2,2.63.28,5,.37,7.11s.15,3.9.16,5.37,0,2.57,0,3.4c0,.35,0,.64,0,.88A1,1,0,0,1,128.79,483.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.69,441.57c.1-.16,6.25,3.49,13.75,8.14s13.5,8.55,13.4,8.71-6.25-3.49-13.75-8.15S99.59,441.72,99.69,441.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.12,442.52a5.64,5.64,0,0,1,.87-1l2.55-2.69,8.51-8.74,8.52-8.74c1-1,1.86-1.92,2.58-2.65a5.57,5.57,0,0,1,1-.92,5.19,5.19,0,0,1-.81,1.09c-.56.68-1.39,1.63-2.43,2.8-2.09,2.33-5,5.47-8.38,8.88s-6.4,6.45-8.66,8.61c-1.12,1.09-2.05,1.95-2.69,2.54A4.86,4.86,0,0,1,126.12,442.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.26,432.84s15.27-1,22.29,10.75A27.58,27.58,0,0,1,80.26,432.84Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.86,425.75s12.85,8.32,11.49,21.92A27.55,27.55,0,0,1,100.86,425.75Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.44,400.89S161.3,418.23,145.83,422A32.12,32.12,0,0,1,165.44,400.89Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.18,340.56s20.09,11.84,18.87,32.63A42,42,0,0,1,90.18,340.56Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.25,450.78a8,8,0,0,1-1.22,1.08c-.82.64-2,1.61-3.38,2.83a88.49,88.49,0,0,0-10.11,10.4,87.56,87.56,0,0,0-8.21,12c-.93,1.61-1.64,2.94-2.12,3.87a7.5,7.5,0,0,1-.81,1.4,8.3,8.3,0,0,1,.58-1.52c.4-1,1.06-2.33,1.93-4a74.58,74.58,0,0,1,18.43-22.5c1.46-1.18,2.66-2.09,3.53-2.68A8.42,8.42,0,0,1,160.25,450.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.85,464.26a33.26,33.26,0,0,1,3.42-23.46C150,455.21,143.85,464.26,143.85,464.26Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.65,456.51a24.2,24.2,0,0,1,16.91-3.41C164.37,458.52,156.65,456.51,156.65,456.51Z",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.2,138.37c-3.92-10.16-13.94-21.93-29.19-19l-1.89.29s-11.19,3-13.65,7.4-3.49,13.8-3.2,24.84,19.9,39.94,19.9,39.94l13.5-13.95,17.09-22.13S272.12,148.54,268.2,138.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.66,132.88l-.62-3.51-21.79.12c-6.61.58-12.34,8.45-11.48,15,1,7.31,2.42,16.19,4.33,21.41,3.85,10.5,12.42,10.25,12.42,10.25l2.16,10.75,24-4.39Z",
    style: {
      fill: "#e8aa9a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.46,151.33a1.42,1.42,0,0,0,1.62,1.14,1.34,1.34,0,0,0,1.18-1.53,1.41,1.41,0,0,0-1.61-1.14A1.36,1.36,0,0,0,230.46,151.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.7,148c.18.15,1.47,0,3.18.51s2.9,1.19,3.11,1.14-.07-.25-.59-.58a8.75,8.75,0,0,0-2.46-1,7.65,7.65,0,0,0-2.55-.28C227.82,147.76,227.61,147.89,227.7,148Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.49,148.46a1.42,1.42,0,0,0,1.62,1.14,1.34,1.34,0,0,0,1.18-1.53,1.41,1.41,0,0,0-1.61-1.14A1.36,1.36,0,0,0,245.49,148.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.6,147.54c.23,0,1.12-.88,2.67-1.62s2.88-.94,3-1.11-.2-.14-.79-.06a8.93,8.93,0,0,0-2.46.79,7.74,7.74,0,0,0-2.07,1.39C243.57,147.32,243.49,147.54,243.6,147.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.46,158.22a10.07,10.07,0,0,0-2.51,0c-.39,0-.77,0-.88-.22a1.91,1.91,0,0,1,0-1.18c.18-1,.37-2,.56-3.13.76-4.45,1.23-8.07,1.05-8.1s-.94,3.55-1.7,8c-.18,1.09-.35,2.14-.51,3.13a2.24,2.24,0,0,0,.1,1.54,1,1,0,0,0,.74.44,3.29,3.29,0,0,0,.66,0A9.77,9.77,0,0,0,239.46,158.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.8,161.7a2.74,2.74,0,0,1,2.22-1.47,2.51,2.51,0,0,1,1.88.57,1.59,1.59,0,0,1,.47,1.76,1.84,1.84,0,0,1-1.87.88,5.74,5.74,0,0,1-2.13-.76,1.57,1.57,0,0,1-.51-.36.5.5,0,0,1-.11-.56",
    style: {
      fill: "#d37f6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.07,158.39c-.25,0,.07,1.66-1.1,3.08s-2.92,1.59-2.89,1.82.45.24,1.18.11a4.08,4.08,0,0,0,2.43-1.42,3.61,3.61,0,0,0,.82-2.56C244.44,158.73,244.18,158.36,244.07,158.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.18,140.28c.23.38,1.69-.1,3.48-.24s3.31.07,3.47-.34c.07-.19-.25-.53-.9-.81a5.8,5.8,0,0,0-2.7-.39,5.73,5.73,0,0,0-2.59.84C241.34,139.72,241.08,140.1,241.18,140.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.19,146.85c.33.29,1.29-.27,2.52-.53s2.33-.22,2.51-.62c.07-.19-.16-.5-.69-.73a3.72,3.72,0,0,0-4.05.92C227.11,146.33,227,146.71,227.19,146.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.35,125.52s-6.89,6.8-6.2,16.76c.42,6,2.11,8.86,2.11,8.86.09-5.43,2.8-11.35,28.45-6.83l8.24,4.52s5.23-10.31,0-16.85-11.5-10.46-18.6-10.31S229.35,125.52,229.35,125.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.3,163.79s8.76,19.26,14.51,18.8,14.7-11.86,14.7-11.86l2.37-13.79S233.05,158.31,227.3,163.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.68,130.82c-4.94-5.08-14.23-13.41-24.4-11.36a13.78,13.78,0,0,1,13.22,8.16c4.21,9,1.38,51.07,1.38,51.07l14.85-4.94,3-18.39S267.62,135.9,262.68,130.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,145.65c-2-1.72-4.18-5.16-8.76-4.2s-12.33,3.33-14.72,3-4.92-.79-4.92-.79l-.1.19s1,4,9,4.63,11.38-3.88,17.12-1,15.38.17,15.38.17S281,147.38,279,145.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.1,172.1a3.8,3.8,0,0,1,.07-.6l.27-1.72c.24-1.48.62-3.63,1-6.29a78.42,78.42,0,0,0,.83-9.39,43.61,43.61,0,0,0-1.19-11.42,30,30,0,0,0-4.82-10.36,40.41,40.41,0,0,0-6.38-6.88,62.12,62.12,0,0,0-5-3.87l-1.43-1a2.26,2.26,0,0,1-.48-.37,3.36,3.36,0,0,1,.53.28c.35.2.86.49,1.49.9a50,50,0,0,1,5.17,3.76,39.3,39.3,0,0,1,6.53,6.88,29.88,29.88,0,0,1,4.93,10.51,42.64,42.64,0,0,1,1.17,11.56,72.64,72.64,0,0,1-.95,9.43c-.43,2.67-.86,4.8-1.16,6.28-.15.69-.28,1.25-.37,1.69A2.38,2.38,0,0,1,252.1,172.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.76,150.9a6.78,6.78,0,0,1-.58-1.31,28.44,28.44,0,0,1-1.11-3.74,23.28,23.28,0,0,1,.5-12.78,17.12,17.12,0,0,1,3.75-6,15.3,15.3,0,0,1,4.72-3.39,12.07,12.07,0,0,1,3.77-1.06,7.34,7.34,0,0,1,1.06,0,1.53,1.53,0,0,1,.37,0,17,17,0,0,0-5.05,1.43,15.64,15.64,0,0,0-4.53,3.38,17.32,17.32,0,0,0-3.6,5.89,23.94,23.94,0,0,0-.63,12.53,37.74,37.74,0,0,0,.95,3.76A8.78,8.78,0,0,1,225.76,150.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.08,181a2.64,2.64,0,0,1-1,0,9.25,9.25,0,0,1-2.56-.64,13.86,13.86,0,0,1-6.42-5.7,26.34,26.34,0,0,1-3-8.08c-.23-1.08-.39-2-.48-2.57a3,3,0,0,1-.08-1c.07,0,.37,1.32.92,3.44a28.93,28.93,0,0,0,3.08,7.9,14.22,14.22,0,0,0,6.12,5.63A17.11,17.11,0,0,0,241.08,181Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.72,264.55s20.5,51,33.53,78.71c12.52,26.62,37,73.3,37,73.3a12.45,12.45,0,0,1-10.64-5.82c-4-6.24-13.08-22.77-35-68.57-11.39-23.83-30.77-75.94-30.77-75.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.58,222.72c-3.42,1.51-6.66,3.68-10.38,4.1-6.07.7-11.72-3.49-15.32-8.43s-5.85-10.76-9.45-15.7-9.24-9.13-15.32-8.44l9.77,16.6c5.42,2.37,8.6,7.91,11.94,12.81s8,9.85,13.91,9.88c5.41,0,9.84-4,14.76-6.33a23.61,23.61,0,0,1,24.1,2.89l3-6.23A31.12,31.12,0,0,0,327.58,222.72Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.73,236.53l10,2.16,2.11-.86s4.07-2.63,4.31-5.52-1.4-6.61-1.4-6.61l-4.25-5.17-10.8-1.93Z",
    style: {
      fill: "#e8aa9a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.7,214.88s.54-55,2.59-85.51c2-29.36,7.79-81.75,7.79-81.75a12.46,12.46,0,0,0-7.79,9.3c-1.43,7.26-3.9,26-7.64,76.6-1.94,26.35-1,81.93-1,81.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.7,214.88l-1.45.17-4.62.47h-.07v-.07c-.1-4.66-.22-12.38-.28-22.59s-.07-22.93.24-37.56c.17-7.32.4-15.12,1-23.32s1.26-16.79,2-25.72,1.57-18.21,2.57-27.73c.52-4.77,1.06-9.59,1.75-14.46.34-2.44.71-4.89,1.2-7.34a13.88,13.88,0,0,1,1.29-3.57,12.51,12.51,0,0,1,2.32-3A12.7,12.7,0,0,1,201,47.38l.39-.14,0,.41c-2.53,23.15-4.78,45.16-6.52,65.16s-2.47,38-3,53.17-.71,27.36-.88,35.8c-.08,4.21-.15,7.48-.19,9.72,0,1.1,0,1.94,0,2.52s0,.86,0,.86,0-.3,0-.86,0-1.42,0-2.52c0-2.24.05-5.51.09-9.72.11-8.44.29-20.67.72-35.81s1-33.19,2.85-53.2,4-42,6.47-65.17l.34.27a12.09,12.09,0,0,0-4.11,2.63,11.68,11.68,0,0,0-2.23,2.91,13,13,0,0,0-1.24,3.43c-.49,2.42-.86,4.87-1.2,7.3-.68,4.86-1.23,9.68-1.75,14.44-1,9.52-1.84,18.79-2.6,27.72s-1.42,17.53-2,25.72-.87,16-1.06,23.29c-.35,14.62-.37,27.33-.36,37.54s.1,17.92.12,22.6l-.07-.06,4.59-.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.59,
    y: 208.67,
    width: 6.12,
    height: 6.21,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.48,53.64a2.29,2.29,0,0,1,0,.39c0,.29-.08.68-.14,1.17l-.56,4.46c-.25,1.93-.56,4.3-.87,7s-.71,5.89-1,9.36c-.73,6.94-1.49,15.22-2.17,24.42s-1.29,19.32-1.77,30C189,151.73,188.47,171,188,185c-.24,7-.44,12.59-.57,16.52-.09,1.93-.15,3.44-.2,4.49,0,.5,0,.88-.06,1.17a2.59,2.59,0,0,1,0,.4,2.47,2.47,0,0,1,0-.4c0-.29,0-.68,0-1.17,0-1.06.05-2.56.09-4.49.1-3.93.24-9.57.41-16.53.35-13.95.77-33.24,1.73-54.53.48-10.64,1.12-20.77,1.81-30S192.7,83,193.48,76c.36-3.47.79-6.6,1.13-9.35s.67-5.12.95-7.05.51-3.4.66-4.45c.08-.49.14-.87.18-1.15S196.48,53.64,196.48,53.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.41,
    y: 216.02,
    width: 6.63,
    height: 69.03,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.72 236.83 186.25 241.73 187.79 246.3 189.34 241.5 187.72 236.83",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.72 247.49 186.25 252.39 187.79 256.96 189.34 252.16 187.72 247.49",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.72 258.49 186.25 263.39 187.79 267.96 189.34 263.15 187.72 258.49",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.72 269.49 186.25 274.39 187.79 278.96 189.34 274.15 187.72 269.49",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.72 280.49 186.25 285.05 189.34 285.05 187.72 280.49",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.72 212.63 186.25 217.53 187.79 222.1 189.34 217.3 187.72 212.63",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.42,
    y: 214.88,
    width: 18.84,
    height: 1.14,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,221.75s3-3.82,3.5-3.9a22.31,22.31,0,0,1,3.33.65s1.86,3.41.73,4.3a2.34,2.34,0,0,1-2.28.41s-1.87,2.92-3.25,2.76S183.52,226.05,186,221.75Z",
    style: {
      fill: "#e8aa9a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.86,217.36s-2.27.58-2.27,2.28a8.23,8.23,0,0,0,.57,3l1.13,1.3s-1,.49-.56,2.76l.81,1.22s-1.22,2.19-.81,3a5.56,5.56,0,0,0,1.13,1.46v3c0,.57,1.87,1.14,1.87,1.14s9.58-.24,10-1.38.45-2.19,0-2.6,1.49-.16,1.29-2.28c-.13-1.34-1.9-2-1.9-2s2.6-2.44,1.63-3a9.88,9.88,0,0,0-2.4-.88S182.46,217.2,179.86,217.36Z",
    style: {
      fill: "#e8aa9a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.86,217.36a.82.82,0,0,1,.23,0,2.1,2.1,0,0,1,.66.1,9.48,9.48,0,0,1,2.33,1,53.68,53.68,0,0,1,7.44,5.34h0a7.52,7.52,0,0,1,2.21,2.12,1.6,1.6,0,0,1,.09,1.75,2.41,2.41,0,0,1-1.61.82V228a3,3,0,0,1,1.36.63,2.05,2.05,0,0,1,.73,1.39,2.67,2.67,0,0,1-.3,1.56,3.19,3.19,0,0,1-.51.64l-.3.25-.14.11,0,0h0s0-.09,0-.12v0a5.76,5.76,0,0,1,.21,1.44,4.71,4.71,0,0,1-.06.74,2.62,2.62,0,0,1-.09.38l-.06.18a.67.67,0,0,1-.16.24,3.47,3.47,0,0,1-1.46.57c-.48.11-1,.18-1.45.25-2.48.32-4.9.43-7.2.5h-.08a7.52,7.52,0,0,1-1.31-.54,1.9,1.9,0,0,1-.61-.48.71.71,0,0,1-.12-.46V235c0-.88,0-1.74,0-2.57l.08.18a6.27,6.27,0,0,1-.9-1,2.69,2.69,0,0,1-.34-.63,1.65,1.65,0,0,1,0-.73,8,8,0,0,1,.9-2.34V228l-.8-1.22,0,0v0a5,5,0,0,1-.09-1.62,1.79,1.79,0,0,1,.78-1.35l-.06.28L178,222.75l0,0v0a8.5,8.5,0,0,1-.54-2.75,2.14,2.14,0,0,1,.21-1.14,2.28,2.28,0,0,1,.61-.74,3.86,3.86,0,0,1,1.14-.62,1.44,1.44,0,0,1,.43-.1,6.17,6.17,0,0,0-1.46.85c-1,.66-.78,2.52-.1,4.37l0,0,1.15,1.28.14.16-.2.12a1.45,1.45,0,0,0-.55,1.09,4.38,4.38,0,0,0,.1,1.47l0-.07.82,1.21.07.11-.06.11a8.46,8.46,0,0,0-.83,2.2,1.32,1.32,0,0,0,0,.53,2.4,2.4,0,0,0,.28.51,5.34,5.34,0,0,0,.83,1l.08.07v.11c0,.83,0,1.69,0,2.57,0,.22,0,.48,0,.5a1.69,1.69,0,0,0,.45.33,8.09,8.09,0,0,0,1.21.5h-.08c2.29-.09,4.71-.2,7.15-.52q.72-.09,1.41-.24a3.49,3.49,0,0,0,1.21-.43l0-.05.05-.15c0-.11,0-.21.07-.32a3.49,3.49,0,0,0,0-.65,5,5,0,0,0-.18-1.29v0h0a.37.37,0,0,1,0-.21l.06-.09.1-.09.15-.13a2,2,0,0,0,.27-.23,1.81,1.81,0,0,0,.41-.51,2.2,2.2,0,0,0,.26-1.26,1.94,1.94,0,0,0-1.68-1.6l-1.38-.27,1.4-.2a2,2,0,0,0,1.28-.61,1.17,1.17,0,0,0-.1-1.25,7.49,7.49,0,0,0-2.05-2h0a60.31,60.31,0,0,0-7.28-5.45,10.27,10.27,0,0,0-2.24-1.11,2,2,0,0,0-.63-.15Z",
    style: {
      fill: "#d37f6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.15,228.25a13.94,13.94,0,0,1-6.34-1.15,21.74,21.74,0,0,1-4.08-2.1,5.9,5.9,0,0,1-1.48-1.18c.09-.14,2.46,1.53,5.74,2.79A44.68,44.68,0,0,0,191.15,228.25Z",
    style: {
      fill: "#d37f6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.76,232.37a4.4,4.4,0,0,1-2,.19,14.69,14.69,0,0,1-4.68-1.13,19.51,19.51,0,0,1-4.18-2.36,5.49,5.49,0,0,1-1.47-1.34A44.61,44.61,0,0,0,185.3,231a17.9,17.9,0,0,0,4.51,1.24C191,232.35,191.75,232.28,191.76,232.37Z",
    style: {
      fill: "#d37f6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.15,235.44a12.68,12.68,0,0,1-5.93-.4,15.18,15.18,0,0,1-3.92-1.59,4.16,4.16,0,0,1-1.38-1.08,11,11,0,0,1,1.56.76,21.77,21.77,0,0,0,3.88,1.41A45.21,45.21,0,0,0,191.15,235.44Z",
    style: {
      fill: "#d37f6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.05,220.27c.07,0,.1.28,0,.71a4.44,4.44,0,0,1-.8,1.48,7.45,7.45,0,0,1-1.15,1.2c-.38.28-.72.24-.71.17s.22-.16.46-.45c.44-.54.72-.9,1-1.24C192.63,221.19,192.92,220.26,193.05,220.27Z",
    style: {
      fill: "#d37f6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,262.68l-1.08-11.87-8.78,1.41s-6.72-8.12-7.67-8.06c-.27,0-3.23.09-3.68,1.17a1.74,1.74,0,0,0-.2.67c-.63.15-2.6.92-2.68,4.55,0,0-3.33,1.25-2.52,4.13l.36,1.44a5.23,5.23,0,0,0-.48,4.22c.75,2.34,11.33,6.26,14.11,6.44s12.82-3,12.82-3Z",
    style: {
      fill: "#e8aa9a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.78,225.7c-.11-.66,8.58-7.45,14.89-7l1.13-4.7,12.63-14.4a17.75,17.75,0,0,1,2.52-9.07c2.66-4,5.5-6.24,5.5-7.44s.72,28.32.72,28.32-12.59,27.44-12.67,28.24-18.34,10.12-18.34,10.12-10.75-3.88-11.4-7.28v-2.59S198.4,235.25,196.78,225.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.94,197.2c-.49-.45-6.34-25.08-22.17-25.83l-33.32,10.56s-7.4,22.81-8.72,36.38c-1.18,12.08-7.25,33.58-3.75,51.38l50.23-3.32s11.2-2.06,14.22-13.56S289.44,197.64,288.94,197.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.5,239.69a1.61,1.61,0,0,1,0-.48l.15-1.35c.14-1.16.37-2.85.69-4.93.62-4.17,1.56-9.91,2.7-16.23s2.27-12,3.18-16.14c.45-2.06.84-3.71,1.13-4.86.14-.51.26-.95.35-1.31a2,2,0,0,1,.16-.44,1.53,1.53,0,0,1,0,.47c-.07.36-.16.8-.26,1.33-.25,1.23-.57,2.88-1,4.89-.81,4.12-1.88,9.84-3,16.16s-2.11,12-2.85,16.18c-.35,2-.64,3.67-.85,4.91l-.25,1.34A1.59,1.59,0,0,1,221.5,239.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,283c-.17-1.33-2.54-14.58-2.49-13.29l55.43-5.61v14.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.85,282.19c3.4,0,14.61,116.75,31.75,127.82l13.21,21.07,25,1.79-2.5-7.5s7.5,2.14,5-2.86-11.07-23.22-11.07-23.22,6.07-.71,5.72-6.07-7.5-8.57-8.57-13.57c0,0-5-26.78-2.5-34.64s3.21-23.21,2.85-30.36,0-29.43-6.81-35.83C274.8,276.82,224.85,282.19,224.85,282.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.91,282.49a98.14,98.14,0,0,0-5,32.23c.33,17.11,5,75.5,8.38,80.2s14.43,39.92,14.43,39.92h17.11l6.38-27.17-9.08-126.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.53,307.6a1.64,1.64,0,0,1,0,.32c0,.24,0,.54.07.93.05.85.13,2,.23,3.57.17,3.14.42,7.62.72,13.15.58,11.13,1.37,26.45,2.24,43.37a82.23,82.23,0,0,0,1.54,12.23A47.89,47.89,0,0,0,244.14,392c3.2,6.6,7.2,11.92,10.47,16.4s6,8.11,7.67,10.7c.87,1.29,1.52,2.31,1.94,3,.2.33.36.6.49.8a1.37,1.37,0,0,1,.14.28,1.81,1.81,0,0,1-.19-.25c-.13-.2-.31-.45-.53-.77-.45-.68-1.12-1.68-2-2.95-1.77-2.56-4.45-6.16-7.81-10.6a103.14,103.14,0,0,1-10.6-16.41,48,48,0,0,1-3.84-10.91A82.31,82.31,0,0,1,238.31,369c-.89-16.94-1.57-32.28-2.08-43.39-.24-5.52-.43-10-.57-13.15,0-1.53-.09-2.72-.12-3.58,0-.38,0-.69,0-.93A1,1,0,0,1,235.53,307.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.79,291.22c-.15,0-.5-2.81-1.34-6.21s-1.8-6.07-1.66-6.13a29.61,29.61,0,0,1,3,12.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.64,284a9.52,9.52,0,0,1-1.27-2.82,9.16,9.16,0,0,1-.78-3,9.52,9.52,0,0,1,1.27,2.82A9.11,9.11,0,0,1,266.64,284Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.2,289.13a29.15,29.15,0,0,1,2.72-7.19,14.09,14.09,0,0,1-1.11,3.69A13.87,13.87,0,0,1,227.2,289.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.24,399.29a2.72,2.72,0,0,1-.76-.46c-.47-.32-1.13-.81-1.92-1.45a43.67,43.67,0,0,1-5.71-5.56,63.48,63.48,0,0,1-4.72-6.41,18.26,18.26,0,0,1-1.68-2.84,23.41,23.41,0,0,1,2,2.63c1.19,1.65,2.81,3.93,4.81,6.28a58.22,58.22,0,0,0,5.55,5.62A30.81,30.81,0,0,1,286.24,399.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.83,352.41a13.67,13.67,0,0,1-2.75-1.2,40.23,40.23,0,0,1-11.38-8.87,12.91,12.91,0,0,1-1.82-2.38,26.39,26.39,0,0,1,2.09,2.13,56.34,56.34,0,0,0,5.34,4.79,53.67,53.67,0,0,0,5.95,4A22,22,0,0,1,272.83,352.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.81,431.08l6.28,40.51,18.17-.51s1.42-35.63,0-40-5.54-18.51-5.54-18.51",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.7,469.6l0,1.15s-19.4,8.71-19.56,12.41h38.27l-.3-14.23A22.2,22.2,0,0,1,275.7,469.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.13,470.18v1.15s-19.4,8.13-19.55,11.83h38.75l-.79-13.65A22.18,22.18,0,0,1,242.13,470.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.72,402.14s9.41,67.46,9.42,68.61a25.64,25.64,0,0,0,18.53,0l1.15-35.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.43 470.85 275.54 470.85 275.08 465.07 294.43 465.07 294.43 470.85",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.98 470.85 242.1 470.85 241.64 465.07 260.98 465.07 260.98 470.85",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.69,433.53a11.89,11.89,0,0,1-1.95-1.72c-1.15-1.11-2.69-2.71-4.31-4.54s-3-3.56-4-4.84a13,13,0,0,1-1.46-2.14,13.74,13.74,0,0,1,1.75,1.91c1,1.22,2.46,2.9,4.07,4.73s3.11,3.45,4.19,4.63A14.12,14.12,0,0,1,260.69,433.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.85,174.63s6.23-3.85,11.73,0,15.77,17.6,16.32,24.39-4.22,35.57-4.22,35.57-20.53,33.37-35.2,31.72-45.74-2-45.74-2L200.6,251.1l40.1-21.8s9.51-31.75,10.79-37.07S258,175.82,260.85,174.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.6 252.22 196.76 265.75 204.81 264.05 204.41 249.81 193.6 252.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.08,211s0,.14,0,.41-.08.68-.15,1.19c-.14,1.06-.35,2.61-.62,4.61-.57,4-1.39,9.95-2.43,17.4v.06a148.33,148.33,0,0,1-10.38,14.48,96.35,96.35,0,0,1-7,7.76A46.74,46.74,0,0,1,258.6,264a19.66,19.66,0,0,1-5.54,2.3l-.76.16-.77.08a7.4,7.4,0,0,1-1.56,0c-1.05,0-2.05-.19-3.09-.28-4.13-.37-8.39-.62-12.75-.84-8.71-.43-17.84-.69-27.22-.86l-3.18,0h.06l-7,1.47-.25.05-.06-.24q-1.6-6.9-3.16-13.53l-.06-.26.27-.05,7-1.22-.07,0,40.13-21.65-.09.11,8.08-27.05c1.8-6.21,2.69-9.25,2.89-10,0,0,0,.23-.14.67s-.27,1.09-.49,1.94c-.45,1.7-1.14,4.2-2.06,7.41-1.82,6.42-4.52,15.69-7.91,27.11l0,.07-.07,0-40.08,21.75,0,0h0l-7,1.24.2-.31q1.54,6.61,3.16,13.52l-.3-.2,7-1.46h.06l3.18.05c9.39.17,18.51.44,27.24.87,4.36.23,8.62.48,12.76.87,1,.09,2.08.24,3.08.28a6.75,6.75,0,0,0,1.49,0l.74-.07.73-.16a18.9,18.9,0,0,0,5.41-2.23,47,47,0,0,0,8.78-7,99.57,99.57,0,0,0,7-7.7,150.19,150.19,0,0,0,10.42-14.39l0,.06c1.1-7.45,2-13.33,2.57-17.38.31-2,.55-3.54.71-4.61.08-.5.14-.89.19-1.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.6,251.1a22.35,22.35,0,0,1,2.08,6.25,22.85,22.85,0,0,1,.68,6.55c-.16,0-.43-2.91-1.19-6.44S200.45,251.16,200.6,251.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.66,187.82c-11.38.89-22.7,2.84-34.11,2.9s-23.21-1.92-32.73-8.22c-6.12-4.05-11.3-9.86-18.33-12-2.08-.64-5-.51-8.3,0h0s-12.47-.38-15.68.21-9.53,6.41-12,6.83-11.24-.49-11.24-.49a4.13,4.13,0,0,0-1.42,3.94c.44,2.57-1,1.63,3.55,3.45s13.71,5.93,17.87,0c2.68-3.82,5.47-8,9.48-10.12,9.65-3.08,20.07,1,24.77,8.75,6.24,10.29,25.71,17.72,38.56,21s8.48-.27,25.71-3.55,18.6,1.64,18.6,1.64l6.72-13.56C373.47,187.36,369.5,187.52,365.66,187.82Z",
    style: {
      fill: "#FF725E"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNinjaPana);
export default __webpack_public_path__ + "static/media/Ninja-pana.2e84e3a38b2926307f55fef31efaed99.svg";
export { ForwardRef as ReactComponent };